import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {Card} from 'shells/card/card';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {ModalLightbox} from 'shells/modal/modal-lightbox';
import {TextField} from 'shells/textfield/textfield';
import {Header} from 'shells/typography/header';
import {Title} from 'shells/typography/title';

import {appHistory} from '../../../history';

import {useCreateManagedMeetingTemplate} from './graphql/hooks/use-create-managed-meeting-template';

type Props = {
    onClose: () => void;
};

export function CreateManagedMeetingModal(props: Props) {
    const [name, setName] = React.useState<string>('');
    const {createManagedMeetingTemplate, isLoading, error} = useCreateManagedMeetingTemplate();

    const handleSave = () => {
        createManagedMeetingTemplate({
            name: name,
        }).then((newManagedMeetingPath) => {
            appHistory.push(newManagedMeetingPath);
        });
    };

    return (
        <ModalLightbox onClose={props.onClose}>
            <Card hasBorder={true} hasShadow={false} backgroundColor='white' borderColor='white'>
                <div className='pad-24' style={{width: 400}}>
                    <StackLegacy spacing={24}>
                        <Header> Create new managed meeting</Header>
                        <StackLegacy spacing={16}>
                            <div>
                                <StackLegacy spacing={8}>
                                    <Title>Name this meeting</Title>
                                    <div className='sub-header font-size-normal'>
                                        Give a descriptive name so you can find it later
                                    </div>
                                </StackLegacy>
                            </div>
                            <TextField
                                value={name}
                                onChange={(newName) => setName(newName)}
                                placeholder='30-minute discovery call'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSave();
                                    }
                                }}
                            />
                        </StackLegacy>
                        <div className='flex flex-dir-row justify-sb'>
                            <Button
                                variant='text-secondary'
                                onClick={props.onClose}
                                size='big'
                                noPadding={true}
                            >
                                Cancel
                            </Button>
                            <SaveButton
                                size='big'
                                buttonText='Create meeting'
                                savingText='Saving...'
                                // @ts-expect-error
                                onClick={handleSave}
                                isSaving={isLoading}
                                errorSaving={Boolean(error)}
                                disabled={name.length === 0}
                            />
                        </div>
                    </StackLegacy>
                </div>
            </Card>
        </ModalLightbox>
    );
}
